import { useContext, useSyncExternalStore } from "react"
import { LayerGroup } from "react-leaflet"
import { dynamicPositionStore } from "./dynamicPositionStore"
import { PlayerMarker } from "./PlayerMarker"
import { AuthProvider } from "../globalContext"
import { rangeID } from "./Mapa"

export function PlayerLayer(){
    const entryProvider = useSyncExternalStore(dynamicPositionStore.subscribeNewEntry,dynamicPositionStore.getPlayersIds)
    const {id: userID} = useContext(AuthProvider)

    return (<LayerGroup>
    {
        entryProvider.filter((v) => v!== userID && v!== rangeID).map((id) =>{
            return <PlayerMarker id={id} key={id} showLastSeenInfo={true}/>
        })
    }
  </LayerGroup>
  )
}